<template>
	<div class="d-block my-3">
		<div style="width: 35%; vertical-align: top;" class="d-inline-block">{{ title }}:</div>
		<div style="width: 65%;" class="d-inline-block font-weight-bold">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CardRow',
	props: {
		title: {
			type: String,
			required: true,
		},
	},
};
</script>

<style scoped>

</style>
